import { PlusIcon } from '@phosphor-icons/react';

import { Button } from '@/components/common/button';
import { ExportMenu } from '@/components/common/export-menu';
import { FilterButton } from '@/components/common/filter-button';
import { SearchBar } from '@/components/common/search-bar';
import { useImmersiveStore } from '@/hooks/use-immersive-store';

import { useModuleHeaderConfig } from './module-header-context';
import styles from './page-header.module.scss';

export function PageHeader() {
  const config = useModuleHeaderConfig();
  // A surface below can expand to cover the app chrome (the Customer Map's in-page full screen),
  // and covered is not unmounted — so this header's search, filter and primary action would
  // otherwise stay in the focus order and the a11y tree behind it (PR #310 review).
  const immersive = useImmersiveStore((s) => s.immersive);
  if (!config) return null;

  const { ownerId, title, search, filter, export: exportCfg, primaryAction } = config;

  return (
    <header className={styles.header} inert={immersive}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.toolbar}>
        {search ? (
          // Keyed by the declaring page: the input is uncontrolled and this header outlives the
          // pages beneath it, so without a remount a term typed on one tab stays painted over the
          // next tab's unfiltered list — and a pending debounce would land on it (ADO 121012).
          <SearchBar
            key={ownerId}
            placeholder={search.placeholder}
            onSearch={search.onSearch}
            minChars={search.minChars}
            maxLength={search.maxLength}
            debounceMs={search.debounceMs}
          />
        ) : null}
        {filter ? (
          <FilterButton active={filter.active} onClick={filter.onClick} onClear={filter.onClear} />
        ) : null}
        {exportCfg ? (
          <ExportMenu
            endpoint={exportCfg.endpoint}
            params={exportCfg.params}
            filename={exportCfg.filename}
            formats={exportCfg.formats}
            method={exportCfg.method}
          />
        ) : null}
        {primaryAction ? (
          <Button variant="neutral" onClick={primaryAction.onClick} startIcon={<PlusIcon />}>
            {primaryAction.label}
          </Button>
        ) : null}
      </div>
    </header>
  );
}
